import {
  format,
} from 'date-fns';
import { sToTimeUnits } from './time';

function leftpad(number) {
  return number > 9 ? number.toString() : `0${number}`;
}

export const formatDuration = (durationInSeconds, i18n) => {
  const totalMinutes = Math.floor(durationInSeconds / 60);

  if (totalMinutes === 0) {
    return `${durationInSeconds}${i18n.formatText('time.seconds')}`;
  }

  const hours = Math.floor(totalMinutes / 60);

  if (hours === 0) {
    return `${totalMinutes}${i18n.formatText('time.minutes')}`;
  }

  const onlyMinutes = totalMinutes % 60;

  if (onlyMinutes === 0) {
    return `${hours}${i18n.formatText('time.hours')}`;
  }

  return `${hours}${i18n.formatText('time.hours')} ${onlyMinutes}${i18n.formatText('time.minutes')}`;
};

export const formatClockTime = (epochInSeconds) => {
  const time = new Date(epochInSeconds * 1000);
  const minutes = time.getMinutes();
  return `${time.getHours()}:${leftpad(minutes)}`;
};

export const formatTimeLeft = (timeLeft) => {
  const {
    hours,
    minutes,
    seconds,
  } = sToTimeUnits(timeLeft);

  return `${leftpad(hours)}:${leftpad(minutes)}:${leftpad(seconds)}`;
};

export const formatYYYYMMDD = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1);
  const day = date.getDate();

  return `${year}-${leftpad(month)}-${leftpad(day)}`;
};

export const formatHHmm = ts => format(ts, 'HH:mm');
